<template>
  <div class="progress-bar-container">
    <div class="progress-bar-track">
      <div 
        class="progress-bar-fill" 
        :style="{ width: percentage + '%', backgroundColor: progressColor }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    mainFilters: {
      type: Object,
      default: () => ({}),
    },
    tagId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      colorsPool: [
        "#999b77",
        "#809877",
        "#6b958a",
        "#6d97a5",
        "#7180a8",
        "#8c7caa",
        "#aa7c98",
        "#bc7575",
        "#b49a77",
        "#8a8f9a",
      ],
      progressColor: "#41abc4",
    };
  },
  created() {
    const randomIndex = Math.floor(Math.random() * this.colorsPool.length);
    this.progressColor = this.colorsPool[randomIndex];
  },
};
</script>

<style scoped>
.progress-bar-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.progress-bar-track {
  flex-grow: 1;
  height: 10px;
  background-color: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.3s ease, background-color 0.3s ease;
}

.progress-bar-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #000;
}
</style>
